/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createCheckIn} from '../api'

export const useMutationCreateCheckIn = createReactQueryMutationHook('createCheckIn', createCheckIn)
